export default "__VITE_ASSET__BqthVyri__"